'use strict'

import React from 'react';
import uuid from 'uuid';
import superagent from 'superagent';

import Field from '../components/Field3.jsx';

function isUpdatedPhase(item,existing) {
  return JSON.stringify(item)!==JSON.stringify(existing);
}

class ProjectTypeLifecyclePhases extends React.Component {
  constructor(props) {
    super(props);
    this.state={phases: props.projectType.phases!==undefined ? props.projectType.phases : []};
  }

  sendCommand(command) {
    return new Promise((resolve,reject)=> {
      superagent
        .post("/")
        .send(command)
        .then(response=>{
          resolve(response)
        })
        .catch(error=>{
          reject(error);
        });
    });
  }

  updateLifecycle(event) {
    if (event.details!==undefined && event.details.action==="prioritize") {
      console.log("[WARN] Change of sequence is not supported.");
      alert("Operation not supported, yet.");
      this.setState({phases:this.state.phases});
    } else {
      let newItems=event.target.value.filter(item=>item.id===undefined);
      console.log("Items: "+JSON.stringify(event.target.value));
      console.log("  new: "+JSON.stringify(newItems));
      if (newItems.length>0) {
        let newItemsWithId=newItems.map(item=>({
          id: uuid.v4(),
          text: item.text,
          description: item.description,
          link: item.link
        }));
        this.sendCommand({
          type:"addLifecyclePhase",
          phases: newItemsWithId,
          projectType: {id: this.props.projectType.id}
        })
          .then(response=>{
            let updatedPhases=JSON.parse(response.text).phases
            console.log("Updated lifecycles phase: "+JSON.stringify(updatedPhases));
            this.setState({phases:updatedPhases});
          })
          .catch(error=>{
            console.log("ERROR: "+(error.response!==undefined ? error.response.text : ""),error);
            alert("An error occured, please try again");
            this.setState({phases:this.state.phases});
          });
      } else {
        let updates=event.target.value.filter(item=>isUpdatedPhase(item,this.state.phases.filter(existing=>existing.id===item.id)[0]))
        this.sendCommand({
          type:"updateLifecyclePhase",
          phases: updates,
          projectType: {id: this.props.projectType.id}
        })
          .then(response=>{
            let updatedPhases=JSON.parse(response.text).phases
            console.log("Updated lifecycles phase: "+JSON.stringify(updatedPhases));
            this.setState({phases:updatedPhases});
          })
          .catch(error=>{
            console.log("ERROR: "+(error.response!==undefined ? error.response.text : ""),error);
            alert("An error occured, please try again");
            this.setState({phases:this.state.phases});
          });
//        this.setState({phases:this.state.phases});
      }
    }
  }

  render() {
    let projectType=this.props.projectType;
    return (
      <div >
        <Field
          key={"lifecycle_"+projectType.id}
          language={this.props.language}
          type="table"
          value={this.state.phases}
          title={"Lifecycle for \""+projectType.name+"\""}
          columns={[
            { name: "text", title: "Phase", editable:true, dragable:true },
            { name: "description", title: "Description", editable:true },
            { name: "link", title: "Link to more documentation", editable: true }
          ]}
          includeEmptyLine={true}
          samples={[{text: "Project", description: "What are the expected outputs of this phase?", link:"At which link can more information be found?"}]}
          onChange={this.updateLifecycle.bind(this)}
          />
      </div>
    );
  }
}

export default class LifecycleManagement extends React.Component {

  render() {
    if (this.props.user!==undefined && this.props.tenant.owner.id===this.props.user.id) {
      return (
        <div style={{paddingTop:10,  paddingBottom:20}}>
          <h3>Lifecyle Management</h3><br/>
          A lifecycle can be defined for every Project Type. A project life cycle is the predefined sequence of phases that a project goes through. <br/>
          There can be one or multiple stages in a phase. <br/> <br/>

        {this.props.tenant.projectTypes!==undefined && this.props.tenant.projectTypes.length>0
          ?  (
                this.props.tenant.projectTypes.map(projectType=>(
                  <ProjectTypeLifecyclePhases
                    key={projectType.id}
                    {...this.props}
                    projectType={projectType}
                  />
                ))
            )
          : "There are no Project Types for this project yet. You need to define project types in the 'Project' tab first, then you can define a lifecycle per type here" }
        </div>
      );
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./views/settings/LifecycleManagement.jsx